import { SelectorsFormsValues } from "@components/constructor/components/core/forms/selectors";
import { Dispatch, PayloadAction } from "@reduxjs/toolkit";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import {useGameServerAuto, useGameServers, useLoginServerAuto, useLoginServers} from "./selectors/game.selectors";
import { useAccounts, useCharacters } from "./selectors/user.selectors";
import {GameServer, LoginServer} from "@interfaces/game";
import type { AppDispatch } from "@store/store";

// Use throughout app instead of plain `useDispatch`
export const useAppDispatch = () => useDispatch<AppDispatch>();

// eslint-disable-next-line react-hooks/exhaustive-deps
export const usePromisedDispatch = () => {
    return useDispatch() as <T>(action: ((dispatch: Dispatch, getState: any) => T) | PayloadAction<any>) => T;
};

export const useIsMount = () => {
    const isMountRef = useRef(true);
    useEffect(() => {
        isMountRef.current = false;
    }, []);
    return isMountRef.current;
};

export function useDefaultSelectorFormValues(availableLoginServers?: string[], availableGameServers?: string[]): SelectorsFormsValues {

    const autoLogin = useLoginServerAuto();
    const loginServers = useLoginServers()
        .filter(x => !availableLoginServers || availableLoginServers.includes(x.id));

    let login: LoginServer | null = null;
    if(loginServers.length === 1)
        login = loginServers[0];
    else if(autoLogin && loginServers.some(l => l === autoLogin))
        login = autoLogin;

    const gameServers = useGameServers(login?.id)
        .filter(x => !availableGameServers || availableGameServers.includes(x.id));

    const autoGame = useGameServerAuto();
    let game: GameServer | null = null;
    if(gameServers.length === 1)
        game = gameServers[0];
    else if(autoGame && gameServers.some(g => g === autoGame))
        game = autoGame;

    const accounts = useAccounts(login?.id);
    const account = login && (accounts.length === 1 ? accounts[0] : null);

    const characters = useCharacters(account?.id || '', game?.id);
    const character = account && game && (characters.length === 1 ? characters[0] : null);

    return {
        selected_login_server: login?.id || '',
        selected_game_server: game?.id || '',
        selected_account: account?.id || '',
        selected_character: character?.id || ''
    }
}